/**
 * Format a timestamp into a human-readable relative time string.
 * Examples: "just now", "5m ago", "2h ago", "yesterday", "3d ago", "2w ago", "1mo ago"
 */
export function formatRelativeTime(timestamp: string | null | undefined): string {
  if (!timestamp) return '';

  const viewedDate = new Date(timestamp);
  if (isNaN(viewedDate.getTime())) return '';

  const now = new Date();
  const diffMs = now.getTime() - viewedDate.getTime();

  // Handle future dates or very small differences
  if (diffMs < 0) return 'just now';

  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);

  if (diffSeconds < 60) return 'just now';
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays === 1) return 'yesterday';
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffWeeks < 4) return `${diffWeeks}w ago`;
  if (diffMonths < 12) return `${diffMonths}mo ago`;

  const diffYears = Math.floor(diffMonths / 12);
  return `${diffYears}y ago`;
}
